import { render, staticRenderFns } from "./SmartSearchbarActionSuggestion.vue?vue&type=template&id=1e491419&scoped=true&"
import script from "./SmartSearchbarActionSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SmartSearchbarActionSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e491419",
  null
  
)

export default component.exports